import axios from 'axios';
import qs from 'qs';

import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardValues } from '@features/Unsubscribe/types';
import { useGetAppName } from 'src/utils/hooks';
import { WIZARD_STEPS } from '../сonstants';

type HandleNextProps = {
  query: { email?: string | string[]; user_id?: string | string[] };
  wizard: { goToStep: (step: TpWizardValues) => void };
  url: string;
  eventName: string;
  options?: any;
  successStep: TpWizardValues;
  new_plan_id?: string;
  price_id?: string;
  currency?: string;
  requestAnalytics?: {
    successEventName: string;
    errorEventName: string;
    options: Record<string, unknown>;
  };
};

export const useHandleNext = ({
  query,
  wizard,
  url,
  eventName,
  options = {},
  successStep,
  new_plan_id,
  price_id,
  currency,
  requestAnalytics,
}: HandleNextProps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent,
    trackUnsubscribeRequestError,
    trackUnsubscribeRequestSuccess,
  } = useUnsubscribeAnalytics({ email: query?.email, userId: query?.user_id });
  const app = useGetAppName();
  const formData = {
    app: app,
    email: defaultEventOptions.email,
    user_id: defaultEventOptions.userId,
    new_plan_id: new_plan_id,
    price_id: price_id,
    currency: currency,
  };
  return async () => {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}${url}`,
        data: qs.stringify(formData),
      });

      if (requestAnalytics) {
        trackUnsubscribeRequestSuccess(
          requestAnalytics.successEventName,
          requestAnalytics.options,
          response.status,
        );
      }

      trackUnsubscribeEvent(eventName, options);

      wizard.goToStep(successStep);
    } catch (error) {
      if (requestAnalytics) {
        trackUnsubscribeRequestError(
          requestAnalytics.errorEventName,
          error,
          requestAnalytics.options,
        );
      }
      wizard.goToStep(WIZARD_STEPS.ERROR);
      console.log('error', error);
    }
  };
};
